import { Loading, Message } from 'element-ui'
import axios from '@/utils/request'

// 云销和云采提货单共用动态下载逻辑，文件名由后端提供。
export function downloadPickupPdf(api, pickupId) {
  if (!pickupId) return Promise.resolve()
  const loading = Loading.service({
    lock: true,
    text: '正在生成提货单...',
    background: 'rgba(0, 0, 0, 0.8)'
  })
  return axios.post(api, { pickupId }, { responseType: 'blob' }).then(response => {
    const disposition = response.headers['content-disposition'] || ''
    const match = disposition.match(/filename\*=UTF-8''([^;]+)/i) || disposition.match(/filename="([^"]+)"/i)
    const fileName = match ? decodeURIComponent(match[1]) : '提货单.pdf'
    const url = window.URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    Message.error(error.message || '提货单下载失败，请重试')
  }).finally(() => {
    loading.close()
  })
}
